class RushTheme {
  constructor() {
    this.bindMenu();
    this.bindSearch();
    this.bindReveal();
    this.bindQuantity();
    this.bindVariants();
    this.bindFilters();
    this.bindAjaxProductForms();
  }

  bindMenu() {
    const panel = document.querySelector('[data-mobile-panel]');
    if (!panel) return;
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const open = panel.classList.toggle('is-open');
        document.body.classList.toggle('menu-open', open);
        panel.setAttribute('aria-hidden', String(!open));
        button.setAttribute('aria-expanded', String(open));
      });
    });
  }

  bindSearch() {
    const drawer = document.querySelector('[data-search-drawer]');
    if (!drawer) return;
    document.querySelectorAll('[data-search-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const open = drawer.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
        if (open) drawer.querySelector('input[type="search"]')?.focus();
      });
    });
  }

  bindReveal() {
    const elements = document.querySelectorAll('[data-reveal]');
    if (!elements.length) return;
    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -35px' });
    elements.forEach((element) => observer.observe(element));
  }

  bindQuantity() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-change]');
      if (!button) return;
      const wrapper = button.closest('[data-quantity]');
      const input = wrapper?.querySelector('input[type="number"]');
      if (!input) return;
      const step = Number(button.dataset.quantityChange);
      const minimum = Number(input.min || 1);
      input.value = Math.max(minimum, Number(input.value || minimum) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  bindVariants() {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const json = root.querySelector('[data-product-json]');
      const form = root.querySelector('form[action*="/cart/add"]');
      if (!json || !form) return;
      const product = JSON.parse(json.textContent);
      const selectors = root.querySelectorAll('[data-option-group]');
      const idInput = form.querySelector('[name="id"]');
      const price = root.querySelector('[data-product-price]');
      const addButton = form.querySelector('[name="add"]');

      const update = () => {
        const values = [...selectors].map((selector) => {
          const checked = selector.querySelector('input:checked');
          return checked?.value;
        });
        const variant = product.variants.find((item) => item.options.every((option, index) => option === values[index]));
        if (!variant) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.unavailable;
          return;
        }
        idInput.value = variant.id;
        price.textContent = this.money(variant.price, window.Shopify?.currency?.active || 'USD');
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addButton.dataset.available : addButton.dataset.soldOut;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      selectors.forEach((selector) => selector.addEventListener('change', update));
    });
  }

  money(cents, currency) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  }

  bindFilters() {
    const filter = document.querySelector('[data-filters]');
    if (!filter) return;
    document.querySelectorAll('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
      filter.classList.toggle('is-open');
      document.body.classList.toggle('menu-open', filter.classList.contains('is-open'));
    }));
    filter.querySelector('form')?.addEventListener('change', (event) => {
      if (event.target.matches('input')) event.currentTarget.submit();
    });
  }

  bindAjaxProductForms() {
    document.querySelectorAll('[data-ajax-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[name="add"]');
        if (!button || button.disabled) return;
        button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error((await response.json()).description || 'Error');
          const item = await response.json();
          document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = Number(count.textContent || 0) + item.quantity; });
          this.showToast();
        } catch (error) {
          alert(error.message);
        } finally {
          button.removeAttribute('aria-busy');
        }
      });
    });
  }

  showToast() {
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    window.setTimeout(() => { toast.classList.remove('is-visible'); toast.setAttribute('aria-hidden', 'true'); }, 3500);
  }
}

document.addEventListener('DOMContentLoaded', () => new RushTheme());
